import { Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const CardOverlay = styled(Flex)`
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.4) 0%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0.8) 90%,
        rgba(255, 255, 255, 0.3) 100%
    );
`;
